import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private baseUrl: string;


  constructor(private httpClient: HttpClient) {
    this.baseUrl = `${environment.apiURL}/information`;
  }


  detail() {
    const endpoint: string = this.baseUrl + '/user';
    return this.httpClient.get(endpoint);
  }


  update(data: any) {

    const endpoint: string = this.baseUrl + '/user'
    var formData = new FormData();
    formData = data
    return this.httpClient.put(endpoint, formData);

  }

  updateAvatar(form: FormData) {
    const endpoint: string = this.baseUrl + '/user/avatar'
    return this.httpClient.post(endpoint, form);
  }

  updatePassword(form: any) {
    const endpoint: string = this.baseUrl + '/user/password'
    return this.httpClient.put(endpoint, form);
  }

}
